"use client"
import { useLocaleConfig } from "@/providers/localeConfig"

import configAndLocales from "../../statics/json/configAndLocals.json"

export const useLocaleStrings = () => {
  const locale = useLocaleConfig().locale ?? "de-DE"

  return configAndLocales[locale]?.localeStrings ?? {}
}
